module.exports = __webpack_public_path__ + "img/SL7_4708-Bearbeitet.1927feaf.jpg";